<template>
  <div class="app">
    <router-view />
  </div>
</template>

<style>
@import "assets/style.css";
</style>
